var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/mobilindex"}},[_c('img',{attrs:{"src":require("../assets/icon.png"),"alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"toCharge",attrs:{"to":"/wxh5/mobilrecharging"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1cfb96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/mobilComponents/mobilHeader.vue
// module id = null
// module chunks = 